import { ModeIds } from "@chesshotel/constants";
import React from "react";
import { BulletIcon } from "../../icons/BulletIcon";
import { FaBolt } from "react-icons/fa";
import { FaDragon } from "react-icons/fa";
import { FaDiceSix } from "react-icons/fa";
import { FaPaperPlane } from "react-icons/fa";
import { FaPuzzlePiece } from "react-icons/fa";
import { useRouter } from "next/router";

import styles from "./Leagues.module.css";
import useTranslation from "next-translate/useTranslation";

const LeaguesHeader = ({ activeMode = ModeIds.BULLET }) => {
  const { t } = useTranslation("common");
  const router = useRouter();

  const itemStyles = {
    [ModeIds.BULLET]: styles.sidebarItem,
    [ModeIds.BLITZ]: styles.sidebarItem,
    [ModeIds.RAPID]: styles.sidebarItem,
    [ModeIds.CHESS960]: styles.sidebarItem,
    [ModeIds.DAILY]: styles.sidebarItem,
    [ModeIds.PUZZLE]: styles.sidebarItem,
  };
  itemStyles[activeMode] += " " + styles.active;

  return (
    <div className={styles.sidebar}>
      <div className={styles.menu}>
        <div
          onClick={() => {
            router.replace("/leagues/" + ModeIds.BULLET);
          }}
        >
          <div className={itemStyles[ModeIds.BULLET]}>
            <div className={styles.icon}>
              <BulletIcon />
            </div>
            Bullet
          </div>
        </div>
        <div
          onClick={() => {
            router.replace("/leagues/" + ModeIds.BLITZ);
          }}
        >
          <div className={itemStyles[ModeIds.BLITZ]}>
            <div className={styles.icon}>
              <FaBolt />
            </div>
            Blitz
          </div>
        </div>
        <div
          onClick={() => {
            router.replace("/leagues/" + ModeIds.RAPID);
          }}
        >
          <div className={itemStyles[ModeIds.RAPID]}>
            <div className={styles.icon}>
              <FaDragon />
            </div>
            Rapid
          </div>
        </div>
        <div
          onClick={() => {
            router.replace("/leagues/" + ModeIds.CHESS960);
          }}
        >
          <div className={itemStyles[ModeIds.CHESS960]}>
            <div className={styles.icon}>
              <FaDiceSix />
            </div>
            Chess960
          </div>
        </div>
        <div
          onClick={() => {
            router.replace("/leagues/" + ModeIds.DAILY);
          }}
        >
          <div className={itemStyles[ModeIds.DAILY]}>
            <div className={styles.icon}>
              <FaPaperPlane />
            </div>
            {t("Daily")}
          </div>
        </div>
        <div
          onClick={() => {
            router.replace("/leagues/" + ModeIds.PUZZLE);
          }}
        >
          <div className={itemStyles[ModeIds.PUZZLE]}>
            <div className={styles.icon}>
              <FaPuzzlePiece />
            </div>
            Puzzle
          </div>
        </div>
      </div>
    </div>
  );
};

export default LeaguesHeader;
